





























module.exports =

  data: ->
    notAtTop: false
    toggled: false

  created: ->
    window.addEventListener('scroll', this.onScroll.bind(this), 500);
    this.onScroll();

  methods:

    onScroll: ->
      if ($(window).scrollTop() >= 400)
        @notAtTop = true
      else
        @notAtTop = false;

    anchorScroll: (e) ->
      e.preventDefault();
      self = $(e.currentTarget);
      scrollTo = $('.'+self.data('target'))
      offsetPos = scrollTo.offset().top
      $('html, body').animate({ scrollTop: offsetPos }, 700)
      this.toggled = false

    mobileToggle: ->
      this.toggled = !this.toggled;




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/navigation.vue